import { render, staticRenderFns } from "./NominaAjustePersona.vue?vue&type=template&id=cd4daf5c"
import script from "./NominaAjustePersona.vue?vue&type=script&lang=js"
export * from "./NominaAjustePersona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports